import { SelectField } from '~components/select';
import { selectFieldAdapter } from '../adapters/select-field-adapter';
import { adapted } from '../utils/adapted';

const AdaptedSelectField = adapted(SelectField)(selectFieldAdapter);

export { AdaptedSelectField as SelectField };
